import { Datagrid, ReferenceField, TextField } from 'react-admin';
import TzDateField from '../TzDate/TzDateField';
import ListWidget from './ListWidget';
import { ReactElement } from 'react';

export default function LatestRemarksWidget(): ReactElement {
  return (
    <ListWidget
      title="Latest Remarks"
      resource="merchant_remarks"
      queryOptions={{ meta: { prefetch: ['merchant'] } }}
    >
      <Datagrid bulkActionButtons={false}>
        <TzDateField showDate label="Date" source="attributes.date" />
        <ReferenceField
          label="Merchant"
          source="relationships.merchant.data.id"
          reference="merchants"
        >
          <TextField source="attributes.merchant_name" emptyText="Merchant not set up" />
        </ReferenceField>
        <TextField label="Created By" source="attributes.created_by" />
        <TextField label="Title" source="attributes.title" />
      </Datagrid>
    </ListWidget>
  );
}
